import { vEquipmentType } from '../equipment/utils.ts'
import {
  modes,
  pricingMethods,
  pricingTypes,
  productTypes,
  quoteMethodTypes,
} from '../models/common.ts'
import type { vOutput } from '../validation/index.ts'
import {
  vArray,
  vBoolean,
  vObject,
  vOptional,
  vPicklist,
  vString,
} from '../validation/schema/core.ts'
import { vDateRange } from '../validation/schema/custom.ts'
import { aiUsageTypes } from './reports/ai-usage.ts'
import { biddingOutcomes } from './reports/quotes.ts'

export const timespans = [
  'hourly',
  'daily',
  'weekly',
  'monthly',
  'yearly',
] as const
export type Timespan = (typeof timespans)[number]

export const adminReportFiltersSchema = vObject({
  range: vOptional(vDateRange()),
  timespan: vOptional(vPicklist(timespans)),
  carrierIds: vOptional(vArray(vString())),
  accountIds: vOptional(vArray(vString())),
  modes: vOptional(vArray(vPicklist(modes))),
  equipmentTypes: vOptional(vArray(vEquipmentType())),
  product: vOptional(vArray(vPicklist(productTypes))),
  pricingMethod: vOptional(vPicklist(pricingMethods)),
  pricingType: vOptional(vPicklist(pricingTypes)),
  quoteMethod: vOptional(vPicklist(quoteMethodTypes)),
  includeCustomerRouted: vOptional(vBoolean()),
  client: vOptional(vString()),
  aiUsageType: vOptional(vPicklist(aiUsageTypes)),
  outcome: vOptional(vPicklist(biddingOutcomes)),
})

export type AdminReportFilters = vOutput<typeof adminReportFiltersSchema>

export const DEFAULT_TIMESPAN: Timespan = 'daily'
export const DEFAULT_RANGE = 'last-7-days' as const
